import React, { useContext } from 'react';
import { WeakType } from '../../typescript-migration';
import FeaturedContent, { IContentItems } from '@ifit/mp-featured-content';
import { IFeaturedContentSection } from '@ifit/mp-featured-content-section';
import { IUserLibraryFeaturedContentItem } from '@ifit/gateway-wolf-athenaeum-service';
import FreeFeaturedContent from '../free-featured-content';
import { Themes } from '@ifit/themes/withTheme';
import { useConfig } from '../../store/reducers/config';
import { ThemeContext } from '@ifit/themes/ThemeContext';
import { useDeviceType } from '../../store/device-type';
import { useMembership } from '../../client/query/users';
import { useEquipmentType } from '../../client/query/equipment-type';

interface IProps {
  featuredItems?: Array<
    IUserLibraryFeaturedContentItem | IFeaturedContentSection | IContentItems
  >;
  onRef?: WeakType;
}

export const LibraryFeaturedContent: React.FC<IProps> = ({
  onRef,
  featuredItems,
}) => {
  const themeClass = Themes[useContext(ThemeContext).theme];
  const deviceType = useDeviceType();
  const { equipmentType } = useEquipmentType();
  const { token, useMetricUnits, language } = useConfig();
  const { isPaused, isFreeLibrary } = useMembership();

  return isFreeLibrary ? (
    <FreeFeaturedContent
      freeButExpired={isFreeLibrary && token}
      onRef={onRef}
      isPaused={isPaused}
      themeClass={themeClass}
    />
  ) : (
    <FeaturedContent
      featuredItems={featuredItems}
      isLoading={false}
      useMetricUnits={useMetricUnits}
      classNames={''}
      themeClass={themeClass}
      deviceType={deviceType}
      equipmentType={equipmentType}
      language={language}
    />
  );
};

export default LibraryFeaturedContent;
